import React, { Fragment } from 'react';
import { useAIAnswerContext } from '../../../../ai-answer-context';
import { getTypedJSONResultDataAssistanceService } from '../../../../utils/getTypedJSONResultData';
import { RecentWorkList } from '../recent-work-list';
import { ProfileSection } from '../user-profile-section';
export var AIAnswerWorkResult = function AIAnswerWorkResult() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var answerString = commonAttributes.answerString;
  var workResult = {
    user_metadata_with_activity: getTypedJSONResultDataAssistanceService(answerString).parsedResult
  };
  var userWorkResult = workResult.user_metadata_with_activity[0];
  var activities = userWorkResult.recentActivity;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProfileSection, {
    name: userWorkResult.name,
    email: userWorkResult.email,
    avatarUrl: userWorkResult.avatar_url,
    profileUrl: userWorkResult.profile_url,
    jobTitle: userWorkResult.job_title,
    department: userWorkResult.department,
    location: userWorkResult.location,
    time: userWorkResult.time
  }), /*#__PURE__*/React.createElement(RecentWorkList, {
    name: userWorkResult.name,
    activities: activities,
    viewAllUrl: userWorkResult.viewAllLink
  }));
};